<template>
  <li>
    <div>
      <span v-if="isRoot" @click="toggle">[{{ isOpen ? "-" : "+" }}]</span>
      <h4 class="d-inline">
        {{ node.value }}
      </h4>
      <span @click="$emit('add-child', node)">
        <app-icon class="btn-success rounded-pill ml-4" name="plus" />
      </span>
      <span @click="$emit('remove-child', node)" v-if="!node.isRoot">
        <app-icon class="btn-danger rounded-pill ml-1" name="minus" />
      </span>
      <span @click="$emit('edit-child', node)" v-if="!node.isRoot">
        <app-icon class="btn-warning rounded-pill ml-1" name="edit-2" />
      </span>
    </div>
    <ul v-show="isOpen" v-if="isRoot">
      <scope-tree
        v-for="(child, index) in node.children"
        :key="index"
        :node="child"
        @add-child="$emit('add-child', $event)"
        @remove-child="$emit('remove-child', $event)"
        @edit-child="$emit('edit-child', $event)"
      ></scope-tree>
    </ul>
  </li>
</template>

<script>
export default {
  props: {
    node: Object,
  },
  data: function () {
    return {
      isOpen: true,
    };
  },
  computed: {
    isRoot: function () {
      return this.node.children && this.node.children.length;
    },
  },
  methods: {
    toggle: function () {
      if (this.isRoot) {
        this.isOpen = !this.isOpen;
      }
    },
  },
};
</script>
